import React from 'react';

import { cn } from './utils';


/**
 * Multi-line text input matching the .pen "Text input — states" (uJShi) and the
 * DESIGN.md `input` token: surface-1 bg, hairline-strong border, focus 1px
 * primary + soft glow, danger border when `invalid`. Same state language as
 * `Input`, just taller and resizable.
 */
const Textarea = React.forwardRef((props, ref) => {
  const { className, invalid = false, rows = 4, ...restProps } = props;

  return (
    <textarea
      ref={ref}
      className={cn(
        'w-full rounded-md bg-surface-1 px-3 py-2.5 text-[13px] leading-normal text-ink',
        'placeholder:text-ink-subtle outline-none',
        'border border-hairline-strong',
        'focus-visible:border-primary focus-visible:ring-focus',
        'disabled:cursor-not-allowed disabled:opacity-45',
        'resize-y',
        invalid && 'border-danger focus-visible:border-danger',
        className,
      )}
      rows={rows}
      {...restProps}
    />
  );
});

Textarea.displayName = 'Textarea';

export { Textarea };
export default Textarea;
